var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1356_3895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.67755 10.4402L9.49591 8.62175L9.49592 8.62175L9.96894 8.14873L10.3225 7.79518L9.96894 7.44162L9.49591 6.96859L9.14236 7.32215L9.49591 6.96859L6.03146 3.50412L5.55843 3.03109L5.20488 2.67754L4.85132 3.03109L4.37829 3.50412L2.5599 5.32251C1.88126 6.00115 1.5 6.92158 1.5 7.88133C1.5 8.8411 1.88125 9.76153 2.5599 10.4402L2.55992 10.4402C3.23855 11.1188 4.15897 11.5 5.11872 11.5C6.07847 11.5 6.99889 11.1188 7.67752 10.4402L7.67755 10.4402Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4225 6.7802L11.4225 6.7802L9.88242 8.32035C9.88242 8.32035 9.88241 8.32035 9.88241 8.32036C9.72762 8.47513 9.47668 8.47513 9.32189 8.32036C9.32188 8.32035 9.32188 8.32035 9.32188 8.32035L4.67975 3.67821C4.52497 3.52342 4.52497 3.27246 4.67975 3.11766C4.67976 3.11766 4.67976 3.11766 4.67976 3.11766L6.2199 1.57751C6.90982 0.887593 7.84555 0.5 8.82124 0.5C9.79689 0.5 10.7326 0.887591 11.4225 1.57751C12.1125 2.26744 12.5001 3.20318 12.5001 4.17886C12.5001 5.15455 12.1125 6.09028 11.4225 6.7802Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00031 16.4319L9.79867 17.0074L9.79868 17.0074L10.5266 17.1571L11.0164 17.2578L11.1171 16.7681L11.2668 16.0401L12.3633 10.7086L12.5131 9.98066L12.6138 9.49091L12.124 9.39019L11.3961 9.24047L8.59771 8.66494C7.56775 8.45312 6.49583 8.65911 5.61775 9.23762C4.73964 9.81615 4.12734 10.7198 3.91551 11.7497L3.91551 11.7498C3.70375 12.7797 3.90973 13.8516 4.48824 14.7297C5.06675 15.6078 5.97039 16.22 7.00027 16.4319L7.00031 16.4319Z",
    fill: "#FF8D00",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4327 17.616L12.3319 18.1057L12.4327 17.616L10.1197 17.1403C9.86442 17.0878 9.70007 16.8383 9.75255 16.5831C9.75255 16.5831 9.75255 16.5831 9.75255 16.5831L11.1864 9.61139C11.2389 9.35616 11.4884 9.1918 11.7436 9.24429C11.7436 9.24429 11.7436 9.24429 11.7436 9.24429L14.0566 9.72C15.1037 9.93535 16.0224 10.5578 16.6105 11.4505C17.1986 12.3431 17.408 13.4328 17.1926 14.4799C16.9773 15.527 16.3548 16.4457 15.4622 17.0338C14.5695 17.6219 13.4798 17.8313 12.4327 17.616Z",
    fill: "white",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1356_3895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineIcon);
export default __webpack_public_path__ + "static/media/medicineIcon.d67a952ebffb9d291a9e0e1ba17b246d.svg";
export { ForwardRef as ReactComponent };